// エラーメッセージのマッピング

export const ERROR_MESSAGES = {
  // 共通エラー
  'bad-args': '入力内容に問題があります',
  'not-found': '見つかりませんでした',
  'network-error': 'ネットワークエラーが発生しました',

  // ルーム関連
  'invalid-code': '無効なルームコードです',
  'room-full': 'ルームが満員です',
  'game-started': 'ゲームは既に開始されています',
  'already-started': 'ゲームは既に開始されています',

  // ゲーム開始関連
  'not-host': 'ホストのみがこの操作を行えます',
  'not-enough-players': 'プレイヤーが足りません',
  'too-many-players': 'プレイヤーが多すぎます',
  'not-all-ready': '全員が準備完了していません',
  'no-questions': '問題の読み込みに失敗しました',

  // フェーズ関連
  'not-answering': '回答フェーズではありません',
  'not-countdown': 'カウントダウン中ではありません',
  'not-revealed': '結果表示中ではありません',
  'not-solution': '正解表示中ではありません',
  'not-finished': 'ゲームがまだ終了していません',

  // その他
  'question-not-found': '問題が見つかりませんでした',
};

/**
 * エラーコードから日本語メッセージを取得
 */
export function getErrorMessage(reason, fallback = 'エラーが発生しました') {
  return ERROR_MESSAGES[reason] || fallback;
}
